var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventsFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Events_Fill",
    "data-name": "Events Fill",
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(79 228)",
    fill: "#4b5c68",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "event_1_",
    "data-name": "event (1)",
    transform: "translate(75.245 230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059",
    transform: "translate(18.231 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3290",
    "data-name": "Path 3290",
    d: "M267.893,0h-.02a.823.823,0,0,0-.837.809c0,.009,0,.017,0,.026V2.756h1.682V.834A.83.83,0,0,0,267.893,0Z",
    transform: "translate(-267.036 0)",
    fill: "#347af0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061",
    transform: "translate(6.037 2.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3291",
    "data-name": "Path 3291",
    d: "M21.049,44h-.388v1.085a.356.356,0,0,1-.349.363H17.839a.35.35,0,0,1-.355-.344c0-.007,0-.013,0-.02V44H11.13v1.085a.375.375,0,0,1-.385.363H8.286a.371.371,0,0,1-.38-.361V44H7.558A1.528,1.528,0,0,0,6.037,45.53v1.6H22.576v-1.6A1.534,1.534,0,0,0,21.049,44Z",
    transform: "translate(-6.037 -44.003)",
    fill: "#347af0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063",
    transform: "translate(8.653 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3292",
    "data-name": "Path 3292",
    d: "M62.9,0a.844.844,0,0,0-.862.834V2.76h1.729V.837A.849.849,0,0,0,62.9,0Z",
    transform: "translate(-62.037 -0.003)",
    fill: "#347af0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065",
    transform: "translate(6.037 5.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3293",
    "data-name": "Path 3293",
    d: "M6.037,127v10.228a1.544,1.544,0,0,0,1.521,1.546h6.926a6.407,6.407,0,0,1-.9-3.268,6.324,6.324,0,0,1,9-5.741V127Z",
    transform: "translate(-6.037 -127.003)",
    fill: "#347af0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067",
    transform: "translate(14.326 8.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3294",
    "data-name": "Path 3294",
    d: "M189.021,189.485a5.573,5.573,0,1,0,5.574,5.573A5.573,5.573,0,0,0,189.021,189.485Zm2.2,6.425h-2.505a.39.39,0,0,1-.383-.383v-3.278a.374.374,0,0,1,.748,0v2.914h2.14a.374.374,0,0,1,0,.748Z",
    transform: "translate(-183.448 -189.485)",
    fill: "#347af0"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsFill);
export default __webpack_public_path__ + "static/media/eventsFill.e06826e65c7d68b1618893002374f971.svg";
export { ForwardRef as ReactComponent };